import { createFileRoute, Outlet } from '@tanstack/react-router';
import { ForeignVendorsPage } from '@/pages/foreign-vendors';
import { foreignVendorsSearchSchema } from '@/routes/-shared/foreignVendorsSearchSchema';
import { requireSuperadmin } from '@/routes/-shared/require-superadmin';

/**
 * La lista resta montata e il form dell'alias si apre sopra di lei
 * sull'`Outlet` (`new`, `edit/$id`), come nella webapp. Le API sono dei
 * soli SUPERADMIN: il guard sul layout vale anche per i pannelli figli.
 */
export const Route = createFileRoute('/admin/_layout/foreign-vendors/_layout')({
  beforeLoad: requireSuperadmin,
  component: ForeignVendorsLayout,
  validateSearch: foreignVendorsSearchSchema,
});

function ForeignVendorsLayout() {
  return (
    <>
      <ForeignVendorsPage />
      <Outlet />
    </>
  );
}
